
import { Vue, Options } from 'vue-class-component'

let instanceCounter = 0

@Options({
  name: 'KeyTab',
  props: {
    width: {
      type: [Number, String],
      default: 56,
    },
    height: {
      type: [Number, String],
      default: 40,
    },
  },
})
export default class KeyTab extends Vue {
  private instanceId = `keyTab-${++instanceCounter}`

  get glossId(): string {
    return `${this.instanceId}-gloss`
  }

  get highlightId(): string {
    return `${this.instanceId}-highlight`
  }
}
